export const setAmounts = (state, { amounts }) => {
  state.amounts = amounts;
};

export const setDiscountCode = (state, { discountCode }) => {
  state.discountCode = discountCode;
};

export const setValidDiscountCode = (state, { valid }) => {
  state.validDiscountCode = valid;
};

export const setOrderBumpChecked = (state, { checked }) => {
  state.orderBump.checked = checked;
};

export const setOrderQuantity = (state, value) => {
  state.orderQuantity = Math.max(1, parseInt(value) || 1);
};

export const setPspDisabled = (state, { code, value }) => {
  const psp = state.psps.find((psp) => psp.code === code);
  psp.disabled = value;
};

export const setSelectedPspCode = (state, { code }) => {
  state.selectedPspCode = code;
};

export const setSelectedPaymentType = (state, { type }) => {
  state.selectedPaymentType = type;
};

export const setInputValue = (state, { name, value }) => {
  state.inputs[name].value = value;
};

export const setInputError = (state, { name, value }) => {
  state.inputs[name].error = value;
};
